import { render, staticRenderFns } from "./ParceiroListFiltroModalItemInputTerminal.vue?vue&type=template&id=6164e7b8"
import script from "./ParceiroListFiltroModalItemInputTerminal.vue?vue&type=script&lang=js"
export * from "./ParceiroListFiltroModalItemInputTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports